export const KEY = 'Key';
//# sourceMappingURL=KEY.js.map